import React from 'react';
import * as PropTypes from 'prop-types';
import * as R from 'ramda';
import { Collapse } from 'antd';

import MeetingNotesList from '../../../containers/meeting-notes-simple-list';
import CommentsList from '../../../containers/comments-list';
import TasksList from '../../../containers/tasks-simple-list';
import TalentsList from '../../../containers/talents-simple-list';
import RequestLogsList from '../../../containers/request-logs-simple-list';
import SvgIcon from '../../svg-icon';
import {
  RightPanelWrapper,
  RequestMessage,
  ArrowWrap,
  StyledHeader,
  ImageWrapper,
} from './styled-components';
import { ReactQuillWrapped } from '../../react-quill';

const { Panel } = Collapse;

const Header = ({ title, iconType }) => (
  <StyledHeader>
    <ImageWrapper>
      <SvgIcon type={iconType} fillOpacity={1} />
    </ImageWrapper>
    {title}
  </StyledHeader>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
};

const RightPanel = ({
  logs,
  tasks,
  subject,
  talents,
  contacts,
  requestMessage,
  meetingNotes,
  comments,
  requestId,
  onCollapseKeyChange,
  collapseKey,
}) => {
  const generateListHeader = (type, data) => `${type} (${R.pathOr(0, ['length'], data)})`;
  const logsTitle = `Logs (${R.pathOr(0, ['length'], logs)})`;

  return (
    <RightPanelWrapper>
      <Collapse
        accordion
        activeKey={[collapseKey]}
        onChange={onCollapseKeyChange}
        bordered={false}
        expandIcon={({ isActive }) => (
          <ArrowWrap type="down" rotate={isActive ? 180 : 0} />
        )}
      >
        <Panel
          header={
            <Header
              title="Request message"
              iconType="notice"
            />
          }
          key="1"
        >
          <RequestMessage>
            <ReactQuillWrapped readOnly theme={null} value={requestMessage} />
          </RequestMessage>
        </Panel>
        <Panel
          header={
            <Header
              title={generateListHeader('Meeting notes', meetingNotes)}
              iconType="notes"
            />
          }
          key="2"
        >
          <MeetingNotesList
            requestId={requestId}
            meetingNotes={meetingNotes}
          />
        </Panel>

        <Panel
          header={
            <Header
              title={generateListHeader('Tasks', tasks)}
              iconType="tasks"
            />
          }
          key="3"
        >
          <TasksList
            tasks={tasks}
            subject={subject}
            contacts={contacts}
            requestId={requestId}
          />
        </Panel>

        <Panel
          header={
            <Header
              title={generateListHeader('Talents', talents)}
              iconType="contacts"
            />
          }
          key="4"
        >
          <TalentsList
            talents={talents}
            requestId={requestId}
          />
        </Panel>

        <Panel
          header={
            <Header
              title={logsTitle}
              iconType="logsV1"
            />
          }
          key="5"
          disabled={R.isEmpty(logs)}
        >
          { !R.isEmpty(logs) &&
          <RequestLogsList
            requestId={requestId}
            logs={logs}
          />
          }
        </Panel>

        <Panel
          header={
            <Header
              title={generateListHeader('Comments', comments)}
              iconType="comment"
            />
          }
          key="6"
        >
          <CommentsList
            requestId={requestId}
            comments={comments}
          />
        </Panel>
      </Collapse>
    </RightPanelWrapper>
  );
};

RightPanel.propTypes = {
  logs: PropTypes.array.isRequired,
  tasks: PropTypes.array.isRequired,
  requestMessage: PropTypes.string.isRequired,
  requestId: PropTypes.string.isRequired,
  meetingNotes: PropTypes.array.isRequired,
  comments: PropTypes.array.isRequired,
  onCollapseKeyChange: PropTypes.func.isRequired,
  collapseKey: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  contacts: PropTypes.array,
  talents: PropTypes.array,
};

RightPanel.defaultProps = {
  contacts: [],
  talents: [],
};

export default RightPanel;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/right-panel/index.js